import { intersection, isEmpty } from 'libraries/lodash'
import { useSelector } from 'react-redux'
import selectAllRoles from 'redux/selectors/selectAllRoles'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const useMenu = (menuSelector) => {
  const isLogged = useSelector(selectIsLogged)
  const userRoles = useSelector(selectAllRoles)
  const menuItems = useSelector(menuSelector)

  // At the moment logged out users get the full menu
  const restrict = isLogged && !isEmpty(userRoles)

  const menu = [...menuItems] // a mutable copy of the menuItems

  return !restrict // essentially an isLogged that waits for the role data
    ? menu.map((linkConfig) => { // more "standardised" way to handle menu links that have different targets based on logged status
      if (linkConfig.alternativeUrl) {
        return { ...linkConfig, url: linkConfig.alternativeUrl, externalLink: true }
      }
      return linkConfig
    })
    : menu.filter(({ availableToRoles, hideToLogged }) => // apply menu restrictions based on user roles if logged in.
      !hideToLogged && (
        isEmpty(availableToRoles) ||
      !isEmpty(intersection(userRoles, availableToRoles))
      )
    )
}

export default useMenu
